export function getPercentageExportValue(type: string, value: string): string {
  switch (type) {
    case 'xlsx': // XLSX uses 0.01 for 1%
      return (+value / 100).toString();
    default: // CSV just displays value without any formatting
      return value;
  }
}
